import { useEffect, useState } from 'react';
import { Api } from '../../services/api';

import P from 'prop-types';

export const CanhotoCanvas = ({ carga, setCanhoto, setUpdateModal }) => {
  const [canhotos, setCanhotos] = useState(null);

  const findCanhotos = async () => {
    console.log('Só pra confirmar');
    try {
      const all = await Api.get(`/canhotos/${carga}`);
      setCanhotos(all.data);
      console.log(all.data);
    } catch {
      setCanhotos(null);
    }
  };

  useEffect(() => {
    findCanhotos();
  }, [carga]);

  return (
    <div>
      <h4>Lista de canhotos</h4>
      <br />
      <div>
        {canhotos ? (
          canhotos.map((obj) => {
            return (
              <div key={obj.id} className="input-group mb-4">
                <span className="form-control">
                  #{obj.id} - NF {obj.nf}
                </span>
                {!obj.arquivo ? (
                  <div className="btn-group" role="group" aria-label="Basic mixed styles example">
                    <button type="button" className="btn btn-secondary" disabled>
                      Aguardando canhoto
                    </button>
                  </div>
                ) : obj.idStatus == 3 ? (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#modalValidaCanhoto"
                    onClick={() => {
                      setCanhoto(obj.id);
                      setUpdateModal(true);
                    }}
                  >
                    Consultar
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-toggle="modal"
                    data-bs-target="#modalValidaCanhoto"
                    onClick={() => {
                      setCanhoto(obj.id);
                      setUpdateModal(true);
                    }}
                  >
                    Validar
                    <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                      <span className="visually-hidden">New alerts</span>
                    </span>
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <div>Não encontramos nenhuma canhoto</div>
        )}
      </div>
    </div>
  );
};

CanhotoCanvas.propTypes = {
  carga: P.number.isRequired,
  setCanhoto: P.func,
  setUpdateModal: P.func,
};
